import React from "react";
import "./about.css";
import { FaAward, FaBuilding, FaFolderOpen } from "react-icons/fa";

const About = () => {
  return (
    <section id="about">
      <h5>Get to know</h5>
      <h2>About me</h2>
      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image-container">
            <img
              src="../../assets/man1.jpg"
              alt="About image"
              className="about__me-image"
            />
          </div>
        </div>
        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className="about__icon" />
              <h5>Experience</h5>
              <small>3+ years Working</small>
            </article>
            <article className="about__card">
              <FaBuilding className="about__icon" />
              <h5>Organizations</h5>
              <small>2 organizations</small>
            </article>
            <article className="about__card">
              <FaFolderOpen className="about__icon" />
              <h5>Projects</h5>
              <small>10+ completed projects</small>
            </article>
          </div>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Voluptate
            optio labore cumque quibusdam. Est, molestias rerum laboriosam,
            suscipit labore ad nam eos explicabo sit delectus voluptatem
            sapiente atque rem aliquid.
          </p>

          <a href="#contact" className="btn btn-primary">
            Lets talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
